import React from 'react';
import { useVoteStore } from '../../stores/voteStore';
import { Phone } from 'lucide-react';

export const PhoneInput = () => {
  const { phoneNumber, setPhoneNumber, selectedTier } = useVoteStore();

  if (!selectedTier) return null;

  return (
    <div className="space-y-2">
      <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
        Numéro de téléphone
      </label>
      <div className="relative rounded-md shadow-sm">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Phone className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="tel"
          id="phone"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
          placeholder="6XX XXX XXX"
        />
      </div>
      <p className="text-sm text-gray-500">
        Ce numéro sera utilisé pour le paiement via Mobile Money
      </p>
    </div>
  );
};